import React, { Component } from "react";
import {
  Box,
  TextField,
  IconButton,
  ClickAwayListener,
  InputAdornment,
} from "@material-ui/core";
import { SendRounded, Mood, Gif, Search, Close } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { Picker } from "emoji-mart";
//import data from "emoji-mart/data/messenger.json";
import "emoji-mart/css/emoji-mart.css";
import { Grid } from "@giphy/react-components";
import { GiphyFetch } from "@giphy/js-fetch-api";
import myStyles from "./Style";
import { FirebaseContext } from "../../FirebaseInit";
import ResizeObserver from "react-resize-observer";

class ChatInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      showPicker: false,
      gifWidth: null,
      gif: "",
      gifIsOpen: false,
      fetchGifs: (offset) => {
        return this.gf.trending({ offset, limit: 10 });
      },
    };
    this.gf = new GiphyFetch("Ih7pnIzKf1aLQUtf5R55n8HBncTdhZxz");
    this.sendMessage = this.sendMessage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.showEmojiPicker = this.showEmojiPicker.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.container = React.createRef();
    this.handleSearch = this.handleSearch.bind(this);
    this.toggleGif = this.toggleGif.bind(this);
  }

  toggleGif() {
    this.setState({ gifIsOpen: !this.state.gifIsOpen });
  }

  handleResize(rect) {
    this.setState({
      gifWidth: rect.width - 20,
    });
  }

  handleSearch(e) {
    const gif = e.target.value;
    if (gif === "") {
      this.setState({
        fetchGifs: (offset) => {
          return this.gf.trending({ offset, limit: 10 });
        },
        gif,
      });
    } else {
      this.setState({
        fetchGifs: (offset) => {
          return this.gf.search(gif, { sort: "relevant", offset, limit: 10 });
        },
        gif,
      });
    }
  }

  sendMessage(firebase, e) {
    if (e.images) {
      let link;
      if (e.images.downsized_small && e.images.downsized_small.mp4)
        link = e.images.downsized_small.mp4;
      else if (e.images.original_mp4 && e.images.original_mp4.mp4)
        link = e.images.original_mp4.mp4;
      else link = e.images.original.mp4;
      this.setState({ gifIsOpen: false });
      if (this.props.chaType === "private") {
        const message = {
          link,
          senderEmail: this.props.user.email,
          senderId: this.props.user.uid,
          timestamp: firebase.fs.Timestamp.now(),
        };

        const membersInfo = {
          [this.props.user.uid]: {
            lastmod: firebase.fs.Timestamp.now(),
          },
          [this.props.chatData.uid]: {
            lastmod: firebase.fs.Timestamp.now(),
          },
        };

        firebase
          .fs()
          .collection("chats")
          .doc(this.props.chatData.id)
          .collection("messages")
          .add({ ...message })
          .then(() => {
            if (
              this.props.chatData.activeMembers.findIndex((item) => {
                return item === this.props.chatData.email;
              }) === -1
            ) {
              let order = this.props.user.uid < this.props.chatData.uid ? 0 : 1;
              let status = order === 0 ? "status2" : "status1";
              firebase
                .fs()
                .collection("chats")
                .doc(this.props.chatData.id)
                .set(
                  {
                    membersInfo: membersInfo,
                    activeMembers: firebase.fs.FieldValue.arrayUnion(
                      this.props.chatData.email
                    ),
                    lastmod: firebase.fs.Timestamp.now(),
                    unread: this.props.chatData.email,
                    count: firebase.fs.FieldValue.increment(1),
                    [status]: "Out",
                  },
                  { merge: true }
                );
            } else {
              if (this.props.chatData.recStatus === "In") {
                firebase
                  .fs()
                  .collection("chats")
                  .doc(this.props.chatData.id)
                  .set(
                    {
                      membersInfo: membersInfo,
                      lastmod: firebase.fs.Timestamp.now(),
                    },
                    { merge: true }
                  );
              } else {
                firebase
                  .fs()
                  .collection("chats")
                  .doc(this.props.chatData.id)
                  .set(
                    {
                      membersInfo: membersInfo,
                      lastmod: firebase.fs.Timestamp.now(),
                      unread: this.props.chatData.email,
                      count: firebase.fs.FieldValue.increment(1),
                    },
                    { merge: true }
                  );
              }
            }
          })
          .catch((err) =>
            this.props.toggleAlert("Error sending message!", "error")
          );
        this.setState({ message: "" });
      } else {
        const message = {
          link: e.images.original.url,
          senderEmail: this.props.user.email,
          senderId: this.props.user.uid,
          timestamp: firebase.fs.Timestamp.now(),
        };

        firebase
          .fs()
          .collection("groups")
          .doc(this.props.chatData.id)
          .collection("messages")
          .add({ ...message })
          .then(() => {
            let unread = this.props.chatData.unread;
            let test = {};
            Object.keys(unread).forEach((key) => {
              if (unread[key].status === "Out")
                test[key] = {
                  count: firebase.fs.FieldValue.increment(1),
                  status: "Out",
                };
            });

            if (Object.keys(test).length !== 0)
              firebase
                .fs()
                .collection("groups")
                .doc(this.props.chatData.id)
                .set(
                  {
                    unread: test,
                    lastmod: firebase.fs.Timestamp.now(),
                    deleted: [],
                  },
                  { merge: true }
                )
                .catch((err) => {});
            else
              firebase
                .fs()
                .collection("groups")
                .doc(this.props.chatData.id)
                .set(
                  {
                    lastmod: firebase.fs.Timestamp.now(),
                  },
                  { merge: true }
                )
                .catch((err) => {});
          })
          .catch((err) =>
            this.props.toggleDialog("Error sending message!", "error")
          );
        this.setState({ message: "" });
      }
      return;
    }

    if (e.key === "Enter" || e.currentTarget.name === "send") {
      if (this.state.message.trim() === "") {
        this.setState({ message: "" });
        return;
      }

      if (this.props.chaType === "private") {
        const message = {
          message: this.state.message,
          senderEmail: this.props.user.email,
          senderId: this.props.user.uid,
          timestamp: firebase.fs.Timestamp.now(),
        };

        const membersInfo = {
          [this.props.user.uid]: {
            lastmod: firebase.fs.Timestamp.now(),
          },
          [this.props.chatData.uid]: {
            lastmod: firebase.fs.Timestamp.now(),
          },
        };

        firebase
          .fs()
          .collection("chats")
          .doc(this.props.chatData.id)
          .collection("messages")
          .add({ ...message })
          .then(() => {
            if (
              this.props.chatData.activeMembers.findIndex((item) => {
                return item === this.props.chatData.email;
              }) === -1
            ) {
              let order = this.props.user.uid < this.props.chatData.uid ? 0 : 1;
              let status = order === 0 ? "status2" : "status1";
              firebase
                .fs()
                .collection("chats")
                .doc(this.props.chatData.id)
                .set(
                  {
                    membersInfo: membersInfo,
                    activeMembers: firebase.fs.FieldValue.arrayUnion(
                      this.props.chatData.email
                    ),
                    lastmod: firebase.fs.Timestamp.now(),
                    unread: this.props.chatData.email,
                    count: firebase.fs.FieldValue.increment(1),
                    [status]: "Out",
                  },
                  { merge: true }
                );
            } else {
              if (this.props.chatData.recStatus === "In") {
                firebase
                  .fs()
                  .collection("chats")
                  .doc(this.props.chatData.id)
                  .set(
                    {
                      membersInfo: membersInfo,
                      lastmod: firebase.fs.Timestamp.now(),
                    },
                    { merge: true }
                  );
              } else {
                firebase
                  .fs()
                  .collection("chats")
                  .doc(this.props.chatData.id)
                  .set(
                    {
                      membersInfo: membersInfo,
                      lastmod: firebase.fs.Timestamp.now(),
                      unread: this.props.chatData.email,
                      count: firebase.fs.FieldValue.increment(1),
                    },
                    { merge: true }
                  );
              }
            }
          })
          .catch((err) =>
            this.props.toggleAlert("Error sending message!", "error")
          );
        this.setState({ message: "" });
      } else {
        const message = {
          message: this.state.message,
          senderEmail: this.props.user.email,
          senderId: this.props.user.uid,
          timestamp: firebase.fs.Timestamp.now(),
        };

        firebase
          .fs()
          .collection("groups")
          .doc(this.props.chatData.id)
          .collection("messages")
          .add({ ...message })
          .then(() => {
            let unread = this.props.chatData.unread;
            let test = {};
            Object.keys(unread).forEach((key) => {
              if (unread[key].status === "Out")
                test[key] = {
                  count: firebase.fs.FieldValue.increment(1),
                  status: "Out",
                };
            });

            if (Object.keys(test).length !== 0)
              firebase
                .fs()
                .collection("groups")
                .doc(this.props.chatData.id)
                .set(
                  {
                    unread: test,
                    lastmod: firebase.fs.Timestamp.now(),
                    deleted: [],
                  },
                  { merge: true }
                )
                .catch((err) => {});
            else
              firebase
                .fs()
                .collection("groups")
                .doc(this.props.chatData.id)
                .set(
                  {
                    lastmod: firebase.fs.Timestamp.now(),
                  },
                  { merge: true }
                )
                .catch((err) => {});
          })
          .catch((err) =>
            this.props.toggleDialog("Error sending message!", "error")
          );
        this.setState({ message: "" });
      }
    }
  }

  handleChange(e) {
    if (e.target && e.target.name === "input")
      this.setState({ message: e.target.value });
    else {
      let sym = e.unified.split("-");
      let codesArray = [];
      sym.forEach((el) => codesArray.push("0x" + el));
      let emoji = String.fromCodePoint(...codesArray);
      this.setState({
        message: this.state.message + emoji,
      });
    }
  }

  showEmojiPicker(away, e) {
    if (
      away &&
      (e.target.parentNode.getAttribute("name") === "mood" ||
        e.target.getAttribute("name") === "mood" ||
        e.target.getAttribute("name") === "show")
    ) {
      return;
    } else this.setState({ showPicker: !this.state.showPicker });
  }

  componentDidMount() {
    const width = this.container.current.offsetWidth;
    this.setState({ gifWidth: width - 20 });
  }

  render() {
    const { classes } = this.props;
    const { message, showPicker, gif, fetchGifs, gifIsOpen } = this.state;
    const firebase = this.context;
    let placeHolder = "Enter your message";
    let blocked = false;
    if (
      this.props.chatData.blocked &&
      this.props.chatData.blocked.indexOf(this.props.chatData.uid) > -1
    ) {
      blocked = true;
      placeHolder = "Unblock to chat";
    } else if (
      this.props.chatData.blocked &&
      this.props.chatData.blocked.indexOf(this.props.user.uid) > -1
    ) {
      blocked = true;
      placeHolder = "You are blocked";
    }

    return (
      <Box p="5px" boxShadow={1} ref={this.container}>
        <TextField
          disabled={blocked}
          fullWidth
          variant="outlined"
          placeholder={placeHolder}
          autoFocus
          value={message}
          onKeyDown={this.sendMessage.bind(this, firebase)}
          onChange={this.handleChange}
          name="input"
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment>
                <IconButton
                  name="send"
                  color="primary"
                  onClick={this.sendMessage.bind(this, firebase)}
                  disabled={message.trim() === ""}
                  size="small"
                >
                  <SendRounded />
                </IconButton>
                <IconButton
                  name="show"
                  color="secondary"
                  onClick={this.showEmojiPicker.bind(this, false)}
                  size="small"
                  disabled={blocked}
                >
                  <Mood name="mood" />
                </IconButton>
                <IconButton
                  name="gif"
                  onClick={this.toggleGif}
                  size="small"
                  disabled={blocked}
                >
                  <Gif name="gif" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {showPicker && (
          <ClickAwayListener
            onClickAway={this.showEmojiPicker.bind(this, true)}
          >
            <Box className={classes.picker}>
              <Picker
                style={{ position: "static", width: "100%" }}
                color="#0288d1"
                title=""
                emoji=""
                set="messenger"
                //data={data}
                onSelect={this.handleChange}
              />
            </Box>
          </ClickAwayListener>
        )}
        <Box
          padding="10px"
          bgcolor="#1e1e1e"
          width="100%"
          position="absolute"
          top={72}
          left={0}
          display={gifIsOpen ? "block" : "none"}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search GIFs"
            autoFocus
            defaultValue=""
            onChange={this.handleSearch}
            name="search"
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment>
                  <Search />
                  <IconButton
                    name="close"
                    color="secondary"
                    onClick={this.toggleGif}
                    size="small"
                  >
                    <Close />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            style={{ marginBottom: "10px" }}
          />
          {gifIsOpen && (
            <Grid
              width={this.state.gifWidth}
              columns={3}
              noLink
              fetchGifs={fetchGifs}
              onGifClick={this.sendMessage.bind(this, firebase)}
              noResultsMessage="no result"
              key={gif}
              hideAttribution
            />
          )}
        </Box>
        <ResizeObserver onResize={this.handleResize} />
      </Box>
    );
  }
}
ChatInput.contextType = FirebaseContext;
export default withStyles(myStyles)(ChatInput);
